import styled from "styled-components";
import { Squarebtn } from "../common/squareBtnProps";
import { useNavigate } from "react-router-dom";
import { useTheme as styledTheme } from "styled-components";
import { useTheme } from "../../context/ThemeContext";
import SearchBar from "../../utils/CustomizedLibraries/customSearchInput";
import FilterSearch from "../../utils/CustomizedLibraries/filterSearch";
import ProjectManage from "../ui/dashboardPrjManage";

const Landing = styled.div`
  // border: 1px solid red;
  .addBtnEndAlign {
    display: flex;
    justify-content: flex-end;
  }
  .searchBar,
  .filterSearch {
    // border: 1px solid green;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .searchBar {
    margin-top: 2rem;
  }
  .filterSearch {
  gap: 20px;
    margin-top: 0.5rem;
  }
`;

const DashboardLanding: React.FC = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const openAddProject = () => {
    navigate("/dashboard/landing/add-project");
  };
  const styledComponentTheme = styledTheme();

  return (
    <Landing>
      <div className="addBtnEndAlign">
        <Squarebtn
          width="170px"
          radius="18px"
          onClick={openAddProject}
          $bacgrndColor={styledComponentTheme.text}
          $color={styledComponentTheme.circularIconTextBg}
          $hoverBackground={styledComponentTheme.circularIconTextBg}
          $hoverColor={styledComponentTheme.text}
        >
          + Create project
        </Squarebtn>
      </div>

      <div className="searchBar">
        {SearchBar({ isDarkMode: theme === "dark" })}
      </div>

      <div className="filterSearch">
        <FilterSearch isDarkMode={theme === "dark"} />
      </div>

      <div>
        {/* Here comes the projects */}
        <ProjectManage />
      </div>
    </Landing>
  );
};

export default DashboardLanding;
